import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Customer ordering site: start the /site request before React mounts (consumed once by orderApi.fetchSite).
const _orderMatch = window.location.pathname.match(/^\/order\/([^/]+)/);
if (_orderMatch && window.fetch) {
  const slug = decodeURIComponent(_orderMatch[1]);
  window.__scSitePrefetch = {
    slug,
    promise: fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/online/${encodeURIComponent(slug)}/site`)
      .then((r) => (r.ok ? r.json() : null)).catch(() => null),
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
